type ContentType =
  | string
  | Array<
      | {
          txt: string;
          className: string;
        }
      | string
    >;

export const getContent = (title: ContentType) => {
  if (typeof title === "string") return title;
  if (Array.isArray(title)) {
    const elements = (title as any[]).map((item) => {
      if (typeof item === "string") return item;
      if (typeof item === "object") {
        const { txt, className } = item || {};
        return (
          <span className={className} key={txt}>
            {txt}
          </span>
        );
      }
      return "";
    });
    return <span>{elements}</span>;
  }
};
